import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgChild = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.458 12.824a1.912 1.912 0 1 0 0-3.824 1.912 1.912 0 0 0 0 3.824Z"
      stroke="#17181A"
    />
    <path
      clipRule="evenodd"
      d="M9.005 14.055c1.559.184 2.418.742 2.576 1.672.159.93.238 2.436.238 4.516.341 1.513.099 2.27-.727 2.27-.633 0-.92-1.935-.863-5.806v5.806l.282 5.047c.359.96.22 1.44-.414 1.44-.635 0-.968-.325-.998-.974l-.41-6.607H8.28l-.41 6.607c-.03.65-.363.974-.998.974s-.773-.48-.414-1.44l.281-5.047v-5.806c.058 3.87-.23 5.806-.863 5.806-.825 0-1.068-.757-.726-2.27 0-2.08.079-3.585.237-4.516.159-.93 1.018-1.488 2.577-1.672a10.61 10.61 0 0 1 1.04 0Z"
      stroke="#17181A"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgChild);
export default Memo;
